var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAlarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 41,
    viewBox: "0 0 39 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4131 31.7091V33.3802C26.4131 35.153 25.7089 36.8531 24.4553 38.1067C23.2018 39.3602 21.5016 40.0645 19.7288 40.0645C17.956 40.0645 16.2558 39.3602 15.0023 38.1067C13.7487 36.8531 13.0445 35.153 13.0445 33.3802V31.7091M37.6595 28.3074C34.9774 25.0248 33.0838 23.3537 33.0838 14.3038C33.0838 6.01625 27.9385 3.06366 24.4553 1.62967C20.9722 0.195644 17.0995 1.01571 15.3539 1.62967C11.8665 3.06575 6.37895 6.00789 6.37895 14.3038C6.37373 23.3537 4.48019 25.0248 1.7981 28.3074C0.686837 29.6672 1.66024 31.7091 3.60391 31.7091H35.8641C37.7973 31.7091 38.7645 29.661 37.6595 28.3074Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlarm);
export default __webpack_public_path__ + "static/media/IconAlarm.4204e8f902f4057d668fb67f8d169147.svg";
export { ForwardRef as ReactComponent };